import React from 'react';
import classNames from 'classnames';
import styles from '../assets/substitution-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { ISubstitution } from 'src/types/substitution';

interface Props {
    data: Paginated<ISubstitution>;
    getData: (params: QueryParams) => void;
}

const columns: Column<ISubstitution>[] = [
    {
        Header: '#',
        accessor: 'id',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Case Number',
        accessor: 'case',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Student Full Name',
        accessor: 'student',
        Filter: textFilter<ISubstitution>(),
    },

    {
        Header: 'Substituted Provider',
        accessor: 'substituted',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Provider Who  Substitutes',
        accessor: 'whoProvider',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Case Type',
        accessor: 'caseType',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Order Type',
        accessor: 'orderType',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Service Type',
        accessor: 'serviceType',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Session Location',
        accessor: 'sessionLocation',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Session Date',
        accessor: 'sessionDate',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Start Time',
        accessor: 'startTime',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'End Time',
        accessor: 'endTime',
        Filter: textFilter<ISubstitution>(),
    },
    {
        Header: 'Status',
        accessor: 'status',
        Filter: textFilter<ISubstitution>(),
    },
];

const SubstitutionsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<ISubstitution> columns={columns} data={data} getData={getData} />
    </div>
);

export default SubstitutionsGrid;
